import { render, staticRenderFns } from "./ManagePost.vue?vue&type=template&id=a7ba5fea&scoped=true"
import script from "./ManagePost.vue?vue&type=script&lang=js"
export * from "./ManagePost.vue?vue&type=script&lang=js"
import style0 from "./ManagePost.vue?vue&type=style&index=0&id=a7ba5fea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ba5fea",
  null
  
)

export default component.exports